module.exports = __webpack_public_path__ + "dist/img/代账管理.60b138b3.svg";